import Constants from "../constants/constants";

export const GetCountry = (code) => {
    const country = Constants.Countries.filter(country => country.code === code)[0];
    return country;
}